import RenderManager from "../rendering/render-manager";

export function saveJSON(){
    var scene = RenderManager.activeScene;

    var jsonObject = new Object();
    var assets =[]; var positions =[]; var scales =[]; var quaternions =[];
    var exporter = new THREE.OBJExporter();
    var array = scene.children;

    for(var index in array){
        if(array[index].type === 'Group'){

            var curr = array[index];
            var id = generateUniqueNumber();
            name = id;
            //mtl = curr.materialLibraries[0];
            mtl = id;

            var tmp = new Object();
            tmp.name = name;
            tmp.mtl = mtl;
            assets.push(tmp);

            var pos= curr.position;
            positions.push({'x':pos.x, 'y':pos.y, 'z':pos.z});

            var scale= curr.scale;
            scales.push({'x':scale.x, 'y':scale.y, 'z':scale.z});

            var quat = curr.quaternion;
            quaternions.push({'x':quat.x, 'y':quat.y, 'z':quat.z, 'w':quat.w});


            //send the obj file to server with its name
            var objmtl = exporter.parse(curr);
            var obj = objmtl.obj;
            var mtl = objmtl.mtl;



            //make async calls for obj and mtl
            $.ajax({
                url: '/storeFile',
                type:'POST',
                data: {'data':obj, 'name':id, 'ext':'obj', '_token': 'U05pgW6JmPwO15ZyPDA5HzD7ZAZPdSnpRVe15kpW'},
                success: function(){  console.log('uploaded File');}

            });

            $.ajax({
                url: '/storeFile',
                type:'POST',
                data: {'data':mtl, 'name':id, 'ext':'mtl', '_token': 'U05pgW6JmPwO15ZyPDA5HzD7ZAZPdSnpRVe15kpW'},
                success: function(){  console.log('uploaded File');}

            });



            //

        }


    }

    jsonObject.assets = assets;
    jsonObject.positions = positions;
    jsonObject.scales  = scales;
    jsonObject.quaternions = quaternions;


    var json = JSON.stringify(jsonObject);
    console.log(json);

     var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            //document.getElementById("demo").innerHTML = this.responseText;
            // window.location.href =  window.location.href;
            console.log('json Updated');
        }
    };
    xhttp.open("GET", "/updateJSON?json="+json, true);
    xhttp.send();



    function generateUniqueNumber(){
    return Math.ceil(Math.random()*10000000);
    }


}
